// frontend/src/components/QuestionRenderer.jsx

import React from "react";
import {
  Box,
  TextField,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  FormHelperText,
  Alert,
} from "@mui/material";

export default function QuestionRenderer({ q, value, onChange, errorText }) {
  const labelWithStar = q.required ? `${q.label} *` : q.label;

  // Info/message block
  if (q.type === "message") {
    return (
      <Box sx={{ mb: 2 }}>
        <Alert severity="info">{q.message}</Alert>
      </Box>
    );
  }

  // Text / Email inputs
  if (q.type === "text" || q.type === "email") {
    return (
      <Box sx={{ mb: 2 }}>
        <TextField
          fullWidth
          label={labelWithStar}
          type={q.type === "email" ? "email" : "text"}
          value={value || ""}
          onChange={(e) => onChange(q.id, e.target.value)}
          error={Boolean(errorText)}
          helperText={errorText || ""}
          autoFocus={Boolean(q.autoFocus)} // ✅ cursor auto focus when field appears
        />
      </Box>
    );
  }

  // Choice inputs (radio if <=4 options, dropdown if >4 options)
  if (q.type === "choice") {
    const count = (q.options || []).length;

    // Dropdown (single select) for >4 options
    if (count > 4) {
      return (
        <Box sx={{ mb: 2 }}>
          <TextField
            select
            fullWidth
            label={labelWithStar}
            value={value || ""}
            onChange={(e) => onChange(q.id, e.target.value)}
            error={Boolean(errorText)}
            helperText={errorText || ""}
          >
            <MenuItem value="">-- Select --</MenuItem>
            {q.options.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      );
    }

    // Radio for <=4 options
    return (
      <Box sx={{ mb: 2 }}>
        <FormLabel sx={{ fontWeight: 700 }} error={Boolean(errorText)}>
          {labelWithStar}
        </FormLabel>

        <RadioGroup
          value={value || ""}
          onChange={(e) => onChange(q.id, e.target.value)}
        >
          {q.options.map((opt) => (
            <FormControlLabel
              key={opt.value}
              value={opt.value}
              control={<Radio />}
              label={opt.label}
            />
          ))}
        </RadioGroup>

        {errorText ? <FormHelperText error>{errorText}</FormHelperText> : null}
      </Box>
    );
  }

  return null;
}
